import axios from "axios";
import { VERSION, SESSION, HAS_SESSION, IS_ADMINISTRATOR } from "./getters";
import { LOGIN, LOAD_SESSION, LOGOUT } from "./actions";
import { SET_VERSION, SET_SESSION_INFO } from "./mutations";

const state = {
    [VERSION]: "",
    [SESSION]: null,
}

const getters = {
    [VERSION]: state => state[VERSION],
    [HAS_SESSION]: state => state[SESSION] != null,
    [SESSION]: state => state[SESSION],
    [IS_ADMINISTRATOR]: state => {
        var session = state[SESSION];

        if (session === null)
            return false;

        if (session.roles.some(function (role) { return role === "Administrator"; })) {
            return true;
        }

        return false;
    }
}

const actions = {
    [LOGIN]: ({ commit }, loginData) => {
        return new Promise((resolve, reject) => {
            axios.post("Authentication/Login", loginData).then(() => {
                resolve();
            }).catch(error => {
                commit(SET_SESSION_INFO, null);
                reject(error);
            });
        });
    },
    [LOAD_SESSION]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get("Authentication/Session").then((response) => {
                commit(SET_SESSION_INFO, response.data);
                resolve();
            }).catch(error => {
                commit(SET_SESSION_INFO, null);
                reject(error);
            });
        });
    },
    [LOGOUT]: ({ commit }) => {
        return new Promise(resolve => {
            axios.get("Authentication/Logout").then(() => {
                commit(SET_SESSION_INFO, null);
                resolve();
            }).catch(() => {
                commit(SET_SESSION_INFO, null);
                resolve();
            });
        });
    }
}

const mutations = {
    [SET_VERSION]: (state, version) => {
        state[VERSION] = version;
    },
    [SET_SESSION_INFO]: (state, value) => {
        state[SESSION] = value;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}